import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress, Container, CssBaseline, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import HeaderMenu from '../../components/header-menu';
import Footer from '../../components/footer';
import CustomizedSnackbars from '../../components/material-snackbars';
import Api from '../../services/api';
import * as ConfigService from '../../services/config.service';
import * as configActions from '../../redux/actions/configs';
import * as shippingservicesettingsActions from '../../redux/actions/shippingservicesettings';
import * as whitelabelconfigsActions from '../../redux/actions/whitelabelconfigs';
import ConfigEdit from '../config-edit';

class ConfigEntry extends Component {
  constructor(props) {
    super(props);
    const { userSession } = this.props;

    if (userSession == null || userSession.user == null || userSession.user.userrole == null) {
      Api.logoff();
    }

    this.state = {
      loading: true,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: ''
    };

    this.resolvingRoute = false;
    this.unmounted = false;
    this.closeNotification = this.closeNotification.bind(this);
    this.resolveRoute = this.resolveRoute.bind(this);
  }

  componentDidMount() {
    this.resolveRoute();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.resolveRoute();
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  isConfigEditPath() {
    return this.props.location && this.props.location.pathname && this.props.location.pathname.indexOf('/config-edit') > -1;
  }

  hasCurrentConfig() {
    return this.props.configs && this.props.configs.config && this.props.configs.config.id;
  }

  closeNotification() {
    this.setState({ openNotification: false });
  }

  getNotificationMessage(result) {
    const { intl } = this.props;
    if (result && result.response && result.response.data && result.response.data.errors && result.response.data.errors.length > 0) {
      return result.response.data.errors[0];
    }

    if (result && result.errors && result.errors.length > 0) {
      return result.errors[0];
    }

    return intl.formatMessage({ id: 'process.error' });
  }

  normalizeConfig(config, timezoneList) {
    if (!config) {
      return config;
    }

    const normalizedConfig = { ...config };
    const timezoneValue = normalizedConfig.timezone && normalizedConfig.timezone.id
      ? normalizedConfig.timezone.id
      : normalizedConfig.timezone;

    if (timezoneValue != null) {
      let timezone = { id: timezoneValue, name: timezoneValue };
      if (timezoneList && timezoneList.length > 0) {
        const currentTimezone = timezoneList.find(item => `${item.id}` === `${timezoneValue}`);
        if (currentTimezone) {
          timezone = currentTimezone;
        }
      }
      normalizedConfig.timezone = timezone;
    }

    return normalizedConfig;
  }

  setCurrentConfigOnStore(config) {
    this.props.addCurrent(config);

    if (config && config.shippingservicesettings && config.shippingservicesettings.id) {
      this.props.addShippingServiceSettings(config.shippingservicesettings);
    } else {
      this.props.addShippingServiceSettings(null);
    }

    if (config && config.whitelabelconfig && config.whitelabelconfig.id) {
      this.props.addWhiteLabelConfig(config.whitelabelconfig);
    } else {
      this.props.addWhiteLabelConfig(null);
    }
  }

  async loadCurrentConfig() {
    const [configResult, timezoneResult] = await Promise.all([
      ConfigService.getCurrent(),
      ConfigService.getTimeZones()
    ]);

    if (configResult && configResult.success && configResult.data) {
      const timezoneList = timezoneResult && timezoneResult.success ? timezoneResult.data : [];
      const normalizedConfig = this.normalizeConfig(configResult.data, timezoneList);
      this.setCurrentConfigOnStore(normalizedConfig);
      return true;
    }

    const notificationMessage = this.getNotificationMessage(configResult);
    if (!this.unmounted) {
      this.setState({
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage
      });
    }
    if (configResult && configResult.response) {
      Api.kickoff(configResult);
    }
    return false;
  }

  async resolveRoute() {
    if (this.resolvingRoute) {
      return;
    }

    this.resolvingRoute = true;

    const isConfigEditPath = this.isConfigEditPath();
    const language = this.props.match.params.lang;

    if (isConfigEditPath && this.hasCurrentConfig()) {
      if (!this.unmounted) {
        this.setState({ loading: false });
      }
      this.resolvingRoute = false;
      return;
    }

    if (!this.unmounted) {
      this.setState({ loading: true });
    }

    const loaded = await this.loadCurrentConfig();

    if (loaded) {
      if (isConfigEditPath) {
        if (!this.unmounted) {
          this.setState({ loading: false });
        }
      } else {
        this.resolvingRoute = false;
        this.props.history.replace(`/${language}/config-edit`, this.props.location.state);
        return;
      }
    } else if (isConfigEditPath) {
      this.resolvingRoute = false;
      this.props.history.replace(`/${language}/configs`);
      return;
    } else if (!this.unmounted) {
      this.setState({ loading: false });
    }

    this.resolvingRoute = false;
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const isConfigEditPath = this.isConfigEditPath();

    if (isConfigEditPath && this.hasCurrentConfig()) {
      return <ConfigEdit {...this.props} />;
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />
           {/* <Typography variant="h5">
              <FormattedMessage id="menu.configs" />
            </Typography>*/}
{/* 
            {!this.state.loading && (
              <Typography variant="body1" style={{ marginTop: 16 }}>
                {this.state.notificationMessage}
              </Typography>
            )} */}

            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}

ConfigEntry.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  configs: state.configs
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    Object.assign({}, configActions, shippingservicesettingsActions, whitelabelconfigsActions),
    dispatch
  );

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ConfigEntry)));
